export default __webpack_public_path__ + "static/media/trash.b03dd5a4.svg";